import React from "react"
import { Grid } from "@mui/material"
import { makeStyles } from "@mui/styles"

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    margin: "0 !important",
    width: "100% !important",

    "& .MuiGrid-root": {
      margin: 0,
      width: "100%"
    }
  }
})

interface FiltersContainerProps {
  children?: any;
  key?: any;
  className?: any;
  groupTitle?: string;
  xs: any;
}

export const FiltersContainer = (props: any) => {
  const { children, sx = {}, spacing = 1 } = props
  const { container } = useStyles()

  return (
    <Grid container className={container} gap="16px" {...{ sx, spacing }}>
      {children}
    </Grid>
  )
}
